require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-part-four-the-42-year-old-coding-virgin.json") })
        }
      }, "path---blog-part-four-the-42-year-old-coding-virgin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-part-four-the-42-year-old-coding-virgin!./.cache/json/blog-part-four-the-42-year-old-coding-virgin.json
// module id = 1021
// module chunks = 231608221292675